import {
  BaseComboboxInputProps,
  ComboboxInput,
} from "@/lib/Components/Form/Inputs/ComboboxInput";
import {
  PaidDriverListItem,
  proDriverListQuery,
} from "@/app/ProDrivers/Drivers/GraphQL/proDriverListQuery";
import { proDriverRecordQuery } from "@/app/ProDrivers/Drivers/GraphQL/proDriverRecordQuery";
import { ResultOf, VariablesOf } from "@graphql-typed-document-node/core";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { CreateProDriverDialog } from "@/app/ProDrivers/Drivers/Components/Dialogs/CreateProDriverDialog";
import { Highlighter } from "@/lib/Components/Highlighter";

export function ProDriverInput(
  props: BaseComboboxInputProps<
    ResultOf<typeof proDriverListQuery>,
    VariablesOf<typeof proDriverListQuery>,
    PaidDriverListItem
  >,
) {
  const { openAsPromise } = useDialog(CreateProDriverDialog);

  return (
    <ComboboxInput
      document={proDriverListQuery}
      accessor={(res) => res.proDrivers.data}
      getQueryVariables={(search) => ({
        first: 5,
        page: 1,
        search,
      })}
      recordDocument={proDriverRecordQuery}
      recordAccessor={(r) => r.proDriver}
      getInputNode={(r) => r.name}
      getListItemNode={(r, search) => (
        <div>
          <div>
            <Highlighter searchString={search}>{r.name ?? ""}</Highlighter>
          </div>
          <div className="text-muted-foreground text-xs">
            <Highlighter searchString={search}>{r.email ?? ""}</Highlighter>
          </div>
        </div>
      )}
      getViewNode={(r) => r?.name}
      getKey={(r) => r.id}
      fixture={(search) => ({
        label: `Add ${search || "new driver"}`,
        onClick: () => {
          return openAsPromise({
            initialValues: {
              name: search,
            },
          });
        },
      })}
      {...props}
    />
  );
}
